import * as ng from 'angular';

import { tinymceOptions } from '../../../shared';

export const editableFields = {
   preregEmail: [
      {
         key: 'Email',
         detail: 'Email Address'
      },
      {
         key: 'FirstName',
         detail: 'First Name'
      },
      {
         key: 'LastName',
         detail: 'Last Name'
      },
      {
         key: 'WristBandID',
         detail: 'Unique identifier'
      },
      {
         key: 'InviteeFirstName',
         detail: 'Primary guest first name'
      },
      {
         key: 'InviteeLastName',
         detail: 'Primary guest last name'
      },
      {
         key: 'TotalGuests',
         detail: 'Total number of secondary guests'
      },
      {
         key: 'ConfirmedGuests',
         detail: 'Total number of confirmed secondary guests'
      },
      {
         key: 'GuestTypeName',
         detail: 'Guest type name'
      },
      {
         key: 'GuestTypeSlug',
         detail: 'Guest type key/identifier'
      },
      {
         key: 'CampaignName',
         detail: 'Name of the Campaign'
      },
      {
         key: 'MinAge',
         detail: 'Minimum age for campaigns with age gate requirement'
      },
      {
         key: 'EventName',
         detail: 'Name of the Event/Venue'
      },
      {
         key: 'EventAddress',
         detail: 'Address of the Event/Venue'
      },
      {
         key: 'EventAddress2',
         detail: 'Event/Venue Floor, Suite, Building #, etc.'
      },
      {
         key: 'EventCity',
         detail: 'City of the Event/Venue'
      },
      {
         key: 'EventState',
         detail: 'State of the Event/Venue'
      },
      {
         key: 'EventZip',
         detail: 'Zip/Postal Code of the Event/Venue'
      },
      {
         key: 'EventHost',
         detail: 'Host of the Event'
      },
      {
         key: 'EventDate',
         detail: 'Full start date of the event, e.g. "Tuesday, Jan 16, 2008"'
      },
      {
         key: 'EventMonth',
         detail: 'Month of the event start date, e.g. "Jan"'
      },
      {
         key: 'EventDayOfMonth',
         detail: 'Day of month of the event start date, e.g. "16"'
      },
      {
         key: 'EventDayOfWeek',
         detail: 'Day of week of the event start date, e.g. "Tue"'
      },
      {
         key: 'EventTime',
         detail: 'Time of day the event starts, e.g. "8:00 PM"'
      },
      {
         key: 'EventEndTime',
         detail: 'Time of day the event ends, e.g. "11:00 PM"'
      }
   ],
   inviteEmail: [
      {
         key: 'Email',
         detail: 'Email Address'
      },
      {
         key: 'FirstName',
         detail: 'First Name'
      },
      {
         key: 'LastName',
         detail: 'Last Name'
      },
      {
         key: 'InviteeFirstName',
         detail: 'Inviting friend first name'
      },
      {
         key: 'InviteeLastName',
         detail: 'Inviting friend last name'
      },
      {
         key: 'GuestTypeName',
         detail: 'Guest type name'
      },
      {
         key: 'GuestTypeSlug',
         detail: 'Guest type key/identifier'
      },
      {
         key: 'CampaignName',
         detail: 'Name of the Campaign'
      },
      {
         key: 'MinAge',
         detail: 'Minimum age for campaigns with age gate requirement'
      },
      {
         key: 'EventName',
         detail: 'Name of the Event/Venue'
      },
      {
         key: 'EventAddress',
         detail: 'Address of the Event/Venue'
      },
      {
         key: 'EventAddress2',
         detail: 'Event/Venue Floor, Suite, Building #, etc.'
      },
      {
         key: 'EventCity',
         detail: 'City of the Event/Venue'
      },
      {
         key: 'EventState',
         detail: 'State of the Event/Venue'
      },
      {
         key: 'EventZip',
         detail: 'Zip/Postal Code of the Event/Venue'
      },
      {
         key: 'EventHost',
         detail: 'Host of the Event'
      },
      {
         key: 'EventDate',
         detail: 'Full start date of the event, e.g. "Tuesday, Jan 16, 2008'
      },
      {
         key: 'EventMonth',
         detail: 'Month of the event start date, e.g. "Jan"'
      },
      {
         key: 'EventDayOfMonth',
         detail: 'Day of month of the event start date, e.g. "16"'
      },
      {
         key: 'EventDayOfWeek',
         detail: 'Day of week of the event start date, e.g. "Tue"'
      },
      {
         key: 'EventTime',
         detail: 'Time of day the event starts, e.g. "8:00 PM"'
      },
      {
         key: 'EventEndTime',
         detail: 'Time of day the event ends, e.g. "11:00 PM" invite'
      }
   ],
   participantEmail: [
      {
         key: 'Email',
         detail: 'Email Address'
      },
      {
         key: 'FirstName',
         detail: 'First Name'
      },
      {
         key: 'LastName',
         detail: 'Last Name'
      },
      {
         key: 'WristBandID',
         detail: 'Unique identifier'
      },
      {
         key: 'EventName',
         detail: 'Name of the Event/Venue'
      },
      {
         key: 'CampaignName',
         detail: 'Name of the Campaign'
      },
      {
         key: 'Module',
         detail: 'Name of the Event Module'
      }
   ],
   qrSite: [
      {
         key: 'FirstName',
         detail: 'First Name'
      },
      {
         key: 'LastName',
         detail: 'Last Name'
      }, {

         key: 'GuestTypeName',
         detail: 'Guest type name'
      },
      {
         key: 'GuestTypeSlug',
         detail: 'Guest type key/identifier'
      },
      {
         key: 'EventName',
         detail: 'Name of the Event/Venue'
      }
   ]
};

ng.module('e360')
   .directive('experienceText', experienceTextDirective);

export function experienceTextDirective() {
   return {
      restrict: 'A',
      link: {
         pre: experienceTextPreLinkFn,
         post: experienceTextPostLinkFn
      },
      template: '<div ui-tinymce="tinymceOptions" ng-model="experienceText"></div>',
      scope: {
         experienceText: '=',
         editableTextFields: '@'
      }
   };

   function experienceTextPreLinkFn(scope, element, attrs) {
      let options = tinymceOptions;

      if (attrs.editableTextFields) {
         options = ng.extend({
            field_prefix: '*|',
            field_suffix: '|*',
            fields: editableFields[attrs.editableTextFields]
         }, options);

         options.plugins += ' fields noneditable';
         options.toolbar += ' | addField';
      }

      scope.tinymceOptions = options;
   }

   function experienceTextPostLinkFn(scope, element, attrs) {
      element.addClass('editable-text');
   }
}
